function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import withTheme from '../withTheme';
var ATTRIBUTION = process.env.NODE_ENV === 'production' ? 'https://attribution.decidata.tv' : 'http://localhost.decidata.tv:3002';
var BUY = process.env.NODE_ENV === 'production' ? 'https://buy.decidata.tv' : 'http://localhost.decidata.tv:3001';
var CIC = process.env.NODE_ENV === 'production' ? 'https://cic.decidata.tv' : 'http://localhost.decidata.tv:3003';
var INSIGHTS = process.env.NODE_ENV === 'production' ? 'https://insights.decidata.tv' : 'http://localhost.decidata.tv:3004';

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      open: false,
      dropdown: false
    }, _this.open = function () {
      _this.setState({
        open: !_this.state.open,
        dropdown: !_this.state.open
      });
    }, _this.dropdown = function () {
      _this.setState({
        dropdown: !_this.state.dropdown
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Header.prototype.render = function render() {
    var _props = this.props,
        current = _props.current,
        theme = _props.theme,
        signOut = _props.signOut,
        Link = _props.linkComponent,
        userInfoUrl = _props.userInfoUrl;
    var _state = this.state,
        open = _state.open,
        dropdown = _state.dropdown;
    var openMenu = open ? 'open' : '';
    var openDropdown = dropdown ? 'open' : '';
    var isAttribution = current === 'attribution';
    var isBuy = current === 'buy';
    var isCIC = current === 'cic';
    var isInsights = current === 'insights';
    return React.createElement('header', {
      className: openMenu + ' dd-header',
      style: theme && theme.header
    }, React.createElement('div', {
      className: 'dd-container'
    }, React.createElement('button', {
      type: 'button',
      name: 'button',
      className: 'dd-menu-toggle',
      onClick: this.open
    }), React.createElement('div', {
      className: 'dd-logo',
      style: theme && theme.headerLogo
    }), React.createElement('nav', {
      className: 'dd-nav'
    }, React.createElement('ul', {
      className: 'default'
    }, React.createElement('li', {
      className: 'dd-nav-link ' + (isAttribution ? 'active' : '')
    }, React.createElement('a', {
      href: ATTRIBUTION
    }, 'Attribution')), React.createElement('li', {
      className: 'dd-nav-link' + (isBuy ? ' active' : '')
    }, React.createElement('a', {
      href: BUY
    }, 'Buy')), React.createElement('li', {
      className: 'dd-nav-link' + (isCIC ? ' active' : '')
    }, React.createElement('a', {
      href: CIC
    }, 'CIC')), React.createElement('li', {
      className: 'dd-nav-link' + (isInsights ? ' active' : '')
    }, React.createElement('a', {
      href: INSIGHTS
    }, 'inSights'))), React.createElement('div', {
      className: 'dd-user'
    }, React.createElement('div', {
      className: 'dd-user-circle',
      onClick: this.dropdown
    }, React.createElement(FontAwesomeIcon, {
      icon: 'user-circle'
    })), React.createElement('div', {
      className: openDropdown + ' dd-dropdown'
    }, React.createElement('ul', null, React.createElement(Link, {
      to: userInfoUrl,
      onClick: this.dropdown
    }, React.createElement('li', null, React.createElement('p', null, 'Update Password'))), React.createElement('li', {
      onClick: function onClick() {
        return signOut();
      }
    }, React.createElement('p', null, 'Sign Out'))))))));
  };

  return Header;
}(Component);

export default withTheme(Header);